// extracted by mini-css-extract-plugin
export default {"container":"Z4-z","heading":"_4-z","links":"a5-z","copy":"b5-z","subCopy":"c5-z","linksLeft":"d5-z","linksCenter":"e5-z","linksRight":"f5-z","link":"g5-z","onlyLink":"h5-z"};